import React from 'react'
import Draggable from 'react-draggable'
import { CellMeasurer, CellMeasurerCache } from 'react-virtualized'
import { GridCellProps } from 'react-virtualized/dist/es/Grid'

import { mainColors } from '../../../styles/colors'
import { Columns } from '../AutoSizeGrid.types'
import * as S from './HeaderRowCell.styles'

export interface HeaderRowCellProps<RowDataType> {
  cache: CellMeasurerCache
  columns: Columns<RowDataType>[]
  gridCellProps: GridCellProps
  isFixed?: boolean
  onColumnResize: (columnIndex: number, width: number, columnWidth?: number | string) => void
  resizable: boolean
  hasRowBelowHeader: boolean
  disabledHeaderCellFullWidth: boolean
}

export function HeaderRowCell<RowDataType>({
  cache,
  columns,
  gridCellProps,
  isFixed,
  onColumnResize,
  resizable,
  hasRowBelowHeader,
  disabledHeaderCellFullWidth,
}: HeaderRowCellProps<RowDataType>) {
  const { columnIndex, key, parent, rowIndex, style } = gridCellProps
  const column = columns[columnIndex]
  return (
    <CellMeasurer
      cache={cache}
      columnIndex={columnIndex}
      key={key}
      parent={parent}
      rowIndex={rowIndex}
    >
      {() => (
        <S.HeaderRow
          key={key}
          style={style}
          isFirstColumn={columnIndex === 0}
          isLastColumn={columnIndex === columns.length}
          resizable={resizable}
          hasRowBelowHeader={hasRowBelowHeader}
          background={mainColors.white}
          borderStyle={column.borderStyle}
          fixedColumn={isFixed}
        >
          <S.HeaderCell disabledHeaderCellFullWidth={disabledHeaderCellFullWidth}>
            {column.header}
            {column.headerFilter}
          </S.HeaderCell>
          {resizable && (
            <Draggable
              axis="x"
              defaultClassNameDragging="DragHandleActive"
              onStop={(e, { x }) => onColumnResize(columnIndex, x, style?.width)}
              position={{ x: 0, y: 0 }}
            >
              <S.DragLine />
            </Draggable>
          )}
        </S.HeaderRow>
      )}
    </CellMeasurer>
  )
}
